// Gets the display name of a JSX component for dev tools
export const getDisplayName = (Component: React.ComponentType<any>) => {
  return Component.displayName || Component.name || "Unknown";
};
